import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-business-category-filter',
  templateUrl: 'business-category-filter.html',
})
export class BusinessCategoryFilterPage {
	categories: any = [];
	caller: any;
	
	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
	) {
		this.caller = navParams.get('caller');	

		this.categories = [
			{name: "Things to Do", src: "assets/images/thingsToDo.png", id: "1"},
			{name: "Beauty & Spas", src: "assets/images/beautySpas.png", id: "2"},
			{name: "Restaurants", src: "assets/images/restaurants.png", id: "3"},
			{name: "Travel", src: "assets/images/travel.png", id: "4"},
			{name: "Health & Fitness", src: "assets/images/healthFitnes.png", id: "5"},
			{name: "Automotive", src: "assets/images/transportation.png", id: "6"},
			{name: "Goods and Services", src: "assets/images/goods.png", id: "7"},
		];
	}

	filterBonds(category){
		this.caller.filterByCategery(category);

		this.navCtrl.pop();
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad BusinessCategoryFilterPage');
	}

}



// WEBPACK FOOTER //
// ./src/pages/business-category-filter/business-category-filter.ts